import { render, staticRenderFns } from "./EditPeriodicTaskStatus.vue?vue&type=template&id=fbfbbd52&"
import script from "./EditPeriodicTaskStatus.vue?vue&type=script&lang=js&"
export * from "./EditPeriodicTaskStatus.vue?vue&type=script&lang=js&"
import style0 from "./EditPeriodicTaskStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports